<!--Visitor Pass Scan Info-->
<div>
	<button class="btn btn-primary" (click)="onBack()"><i class="fa fa-chevron-left" aria-hidden="true"></i> Back</button>
	<h4 style="text-align: center">Selected Scan:</h4>
	<div class="ScanGrid">
		<!--Left Col-->
		<div>
			<img class="VisitorImage" [src]="VisitorPhoto" />
		</div>

		<!--Right Col-->
		<div class="ExtendedInfoGrid">
			<label>Notes:</label>
			<p>{{ Notes }}</p>

			<label>Scan Date:</label>
			<p>{{ LogDT }}</p>

			<label>Facility:</label>
			<p>{{ FacilityName }}</p>

			<label>Location:</label>
			<p>{{ FacilityLocationName }}</p>
		</div>
	</div>
</div>

<!--Tabs-->
<div>
	<p-tabView [(activeIndex)]="SelectedTab">
		<p-tabPanel>
			<ng-template pTemplate="header">
				<div class="HeaderOuterDiv">
					<div class="HeaderDiv">
						<i class="fa fa-user"></i>
						<span>Info</span>
					</div>
				</div>
			</ng-template>
			<caass-ms-visitor-info [SelectedVisitor]="SelectedVisitor"> </caass-ms-visitor-info>
		</p-tabPanel>

		<p-tabPanel>
			<ng-template pTemplate="header">
				<div class="HeaderOuterDiv">
					<div class="HeaderDiv">
						<i class="fa fa-calendar"></i>
						<span>History</span>
					</div>
				</div>
			</ng-template>
			<caass-ms-visitor-history [SelectedVisitor]="SelectedVisitor"> </caass-ms-visitor-history>
		</p-tabPanel>

		<p-tabPanel>
			<ng-template pTemplate="header">
				<div class="HeaderOuterDiv">
					<div class="HeaderDiv">
						<i class="fa fa-search"></i>
						<span>Offender Lookup</span>
					</div>
				</div>
			</ng-template>
			<caass-ms-visitor-offender-lookup [SelectedVisitor]="SelectedVisitor"> </caass-ms-visitor-offender-lookup>
		</p-tabPanel>

		<p-tabPanel>
			<ng-template pTemplate="header">
				<div class="HeaderOuterDiv">
					<div class="HeaderDiv">
						<i class="fa fa-calendar-check-o"></i>
						<span>Lookup History</span>
					</div>
				</div>
			</ng-template>
			<caass-ms-visitor-offender-lookup-history [SelectedVisitor]="SelectedVisitor"> </caass-ms-visitor-offender-lookup-history>
		</p-tabPanel>

		<!--
        *NOTE: Need DB Changes? One Person per entry in Parent Table 
        Ex. If a parent has 2 kids they have 2 entries in the Person Table
        (And there's no connection between them, but they have the same name)
        -->

		<!--
        <p-tabPanel>
            <ng-template pTemplate="header">
                <div class="HeaderOuterDiv">
                    <div class="HeaderDiv">
                        <i class="fa fa-graduation-cap"></i>
                        <span>Parent/Child</span>
                    </div>
                </div>
            </ng-template>
            <caass-ms-visitor-parent-child
                [SelectedVisitor]="SelectedVisitor">
            </caass-ms-visitor-parent-child>
        </p-tabPanel>
        -->
	</p-tabView>
</div>
